import { CabecaHumana3D, CorpoHumano3D } from './CorpoHumano3D'
import { PecaDetalhe3D } from './PecaDetalhe3D'

export function FiguraVitima3D() {
  return (
    <group name="vitima-civil">
      <CorpoHumano3D cor="#bd7071" corCalca="#394d68" civil />
      <CabecaHumana3D cabelo />
      <PecaDetalhe3D
        posicao={[0, 1.41, 0.115]}
        tamanho={[0.14, 0.045, 0.025]}
        cor="#9a565c"
        raio={0.015}
      />
      <PecaDetalhe3D
        posicao={[0, 0.94, 0.147]}
        tamanho={[0.36, 0.025, 0.025]}
        cor="#273648"
        raio={0.008}
      />
    </group>
  )
}
